// extracted by mini-css-extract-plugin
export default {"app":"app_app__ZSdIq","scrollBar":"app_scrollBar__+oiJp"};